import 'font-awesome/css/font-awesome.css';
import 'slick-slider/slick/slick.scss'
import 'slick-slider/slick/slick-theme.scss'
import 'slick-slider/slick/slick'

import './appointmentForm'

import '../scss/theme.scss'
import {DynamicResponsiveChecker, DynamicResponsiveGroup }from 'responsive-checker'

import { sortNews } from "./news";
import { handleForm } from "./bookingForm";

import $ from 'jquery'
window.$ = $

window.addEventListener('load', () => {
    new DynamicResponsiveChecker([
        new DynamicResponsiveGroup('.top-section .logo', '.top-section nav li:first-child', 20, '.top-section nav'),
        new DynamicResponsiveGroup('.info-line .left .info li:last-child', '.info-line .menu li:first-child', 20, '.info-line .menu'),
        new DynamicResponsiveGroup('.info-line .left .info li:last-child', '.info-line .top-icon', 20, '.info-line .left .info'),
    ]);

    $('.carousel').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 1270,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 830,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    })

    sortNews()
    handleForm()

    document.querySelectorAll('.top-icon')
        .forEach(link => {
            link.addEventListener('click', () => window.scrollTo({top: 0, behavior: 'smooth'}))
        })

    document.querySelectorAll('.hamburger').forEach(link => {
        link.addEventListener('click', () => {
            document.body.classList.add('sidebar-shown')
        })
    })

    document.querySelectorAll('.close-menu').forEach(link => {
        link.addEventListener('click', () => {
            document.body.classList.remove('sidebar-shown')
        })
    })

    document.querySelectorAll('.top-section .menu li').forEach(mainItem => {
        let submenu = null

        const tmp = Array.from(mainItem.classList)
            .filter(c => c.startsWith('menu-item-id-'))
            .map(c => parseInt(c.replace('menu-item-id-', '')))
        if (tmp.length) {
            const mainItemId = tmp.shift()
            const m = document.querySelector(`.submenu[data-parent="${mainItemId}"]`)
            if (m) {
                submenu = m
            }
        }

        mainItem.addEventListener('mouseover', () => {
            document.querySelectorAll('.submenu').forEach(m => m.classList.remove('active'))
            if (submenu) {
                submenu.classList.add('active')
            }
        })
        // mainItem.addEventListener('mouseout', () => {
        //     document.querySelectorAll('.submenu').forEach(m => m.classList.remove('active'))
        // })
    })

    document.querySelectorAll('.submenu.default').forEach(m => m.classList.add('active'))

    document.querySelector('.top-section-container').addEventListener('mouseleave', () => {
        document.querySelectorAll('.submenu').forEach(m => m.classList.remove('active'))
        document.querySelectorAll('.submenu.default').forEach(m => m.classList.add('active'))
    })
})

